import type { FC } from 'react';
import { useState } from 'react';
import { confirmDialog, showErrorToast, showToast } from './ui/feedback';
import {BlockingSpinner} from "./ui";
interface groupProps {
  list: any;
}

const ContactListItem: FC<groupProps> = ({ list }) => {
  const [loadingDelete, setLoadingDelete] = useState(false);

  const [hideItem, setHideItem] = useState(false);

  const deleteList = async (id: number) => {
    const confirmDelete = await confirmDialog({
      title: 'Delete list?',
      message: 'Are you sure you want to delete this list?',
      confirmLabel: 'Delete',
      variant: 'danger',
    });
    if (!confirmDelete) {
      return;
    }
    setLoadingDelete(true);
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const storedJWT = localStorage.getItem('jwt');
    user.email &&
      (await fetch(process.env.REACT_APP_API_URL + '/delete-contact-list.php', {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + storedJWT,
        },
        body: JSON.stringify({
          id: id,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.message === 'success') {
            setHideItem(true);
          } else if (data.error) {
            showErrorToast(data.error);
            setLoadingDelete(false);
          } else {
            showToast({ message: 'Failed, try again', variant: 'error' });
            setLoadingDelete(false);
          }
        })
        .catch((error) => {
          showErrorToast(error);
          setLoadingDelete(false);
        }));
  };

  return (
    !hideItem && (
      <div className="flex items-center justify-between border-b border-gray-200 fade-in ">
        <div>
          <p className="px-3 py-2 overflow-hidden text-sm overflow-ellipsis">
            {list.name}
          </p>
        </div>

        <div className="flex items-center justify-end">
          {loadingDelete ? (<BlockingSpinner/>) : (
            <svg
              onClick={() => deleteList(list.ID)}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-5 h-5 text-red-500 cursor-pointer hover:text-red-600"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18 18 6M6 6l12 12"
              />
            </svg>
          )}
        </div>
      </div>
    )
  );
};
export default ContactListItem;
